import loadable from "@loadable/component";
import ProductListSkeleton from "../../components/ProductList/ProductListSkeleton";

const CategoryPageRoute = loadable(
  () =>
    import(
      /* webpackPreload: true, webpackChunkName: "CATEGORY_PAGE" */ "../CategoryPage"
    ),
  {
    fallback: <ProductListSkeleton />
  }
);

export default CategoryPageRoute;
